import { Button } from "@/components/core/buttons/button";
import Combobox from "@/components/core/forms/combobox";
import { Form, FormDescription } from "@/components/core/forms/form.tsx";
import { FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import Select from "@/components/core/forms/select";
import TagsInput from "@/components/core/forms/tags-input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useRegionMutation } from "../api/queries/region-queries";
import { useUserAssignRoleMutation } from "../api/queries/user-queries";
import roleService from "../api/services/role-service";
import { type Region, regionSchema } from "../types/region";

export default function RegionModal({ data }: { data?: Region }) {
	const { closeModal } = useModalControl();
	const regionMutation = useRegionMutation(data?.id);

	const form = useForm<Region>({
		defaultValues: {
			id: data?.id || "",
			role_id: null,
		},
	});
	const userAssignRoleMutation = useUserAssignRoleMutation();

	const handleSubmit = async (values) => {
		console.log(values);
		await userAssignRoleMutation.mutateAsync(values);
		closeModal();
	};

	const loadRoleOptions = async (value: string) => {
		const items = await roleService.list({
			"filter[search]": value,
		});

		return items.map((item: Role) => ({
			value: item.id,
			label: item.name,
		}));
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="grid grid-cols-12 w-full gap-3 py-3">
					<div className="col-span-12 w-full">
						<FormField
							control={form.control}
							name="role_id"
							render={({ field }) => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel required>Roles</FormLabel>
										<FormDescription />
									</div>
									<FormGroup iconPosition="left">
										<Combobox
											defaultValue={field.value}
											onValueChange={(value) => {
												field.onChange(value);
											}}
											loadOptions={loadRoleOptions}
										/>
									</FormGroup>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-2">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button className="" variant="default">
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
